//----------------------------------------------------------------------------------------

// Author : Guillaume Quimper
// Version 2.0
// Created: November 2014 (updated 2019)

//----------------------------------------------------------------------------------------

// Import Styles
import './../sass/main.scss';

import Player from '@vimeo/player';

function loadVimeoPlayer() {
  const vimeoPlayer = document.getElementById('vimeoPlayer');
  if (vimeoPlayer) {
    const vimeoId = vimeoPlayer.getAttribute('data-video-id');
    if (vimeoId) {
      const player = new Player('vimeoPlayer', {
        id: vimeoId,
        title: false,
        byline: false,
        color: '4d4d4d',
        width: 1080
      });
    }
  }
}

loadVimeoPlayer();

jQuery(function($) {
  // --------------------------------------------------
  // Mobile Check
  // Ref: http://stackoverflow.com/a/11381730/989439
  // --------------------------------------------------

  function mobilecheck() {
    var check = false;
    (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  // --------------------------------------------------
  // Set Panels
  // --------------------------------------------------

  function setPanels() {
    var windowHeight = $(window).height(),
    headerHeight = $('#main-header').height(),
    footerHeight = $('#main-footer').height(),
    viewableHeight = windowHeight - headerHeight - footerHeight,
    sliderHeight = windowHeight - headerHeight;

    $('#demo-reel').css({'height': viewableHeight});
    $('#home-slider').css({'height': sliderHeight});
    $('#portfolio-grid').css({'min-height': viewableHeight});
  }

  function resetPanels() {
    $('#sliding-panel').removeAttr('style');
    $('body').removeClass('mobile-menu-open');
  }

  setPanels();

  // --------------------------------------------------
  // Mobile Nav
  // --------------------------------------------------

  var	eventtype = mobilecheck() ? 'touchstart' : 'click';

  $('#mobile-menu-trigger').on(eventtype, function(ev){
    ev.stopPropagation();
    ev.preventDefault();

    $('body').toggleClass('mobile-menu-open');
    return false;

  });

  // --------------------------------------------------
  // Team
  // --------------------------------------------------
  $('#team .col').matchHeight();

  //------------------------------------------------------------------------
  // Safer Mailto
  //------------------------------------------------------------------------
  $.fn.mailto = function() {
    return this.each(function(){
      var email = $(this).html().replace(/\s*\(.+\)\s*/, "@");
      var thisClass = $(this).attr('class');
      $(this).before('<a href="mailto:' + email + '" class="' + thisClass + '">' + email + '</a>').remove();
    });
  };
  $('.mailto').mailto();


  // --------------------------------------------------
  // Home Page Slider
  // --------------------------------------------------

  var totalImgSlide = $('#home-slider .rsContent').length;

  if( totalImgSlide < 3 ) {
    var loopEnabled = false,
    loopRewindEnabled = true;
  } else {
    var loopEnabled = true,
    loopRewindEnabled = false;
  }

  var slider = $('#home-slider').royalSlider({
    arrowsNav: false,
    loop: loopEnabled,
    loopRewind: loopRewindEnabled,
    keyboardNavEnabled: true,
    controlsInside: false,
    imageScaleMode: 'fill',
    arrowsNavAutoHide: false,
    autoScaleSlider: false,
    slidesSpacing: 0,
    controlNavigation: 'bullets',
    thumbsFitInViewport: false,
    navigateByClick: false,
    // autoPlay: false,
    transitionType:'move',
    globalCaption: false,
    imgWidth: 1920,
    imgHeight: 1080,
    autoPlay: {
      enabled: true,
      pauseOnHover: true,
      stopAtAction: false,
      delay: 6500
    }
  }).data('royalSlider');

  if(slider) {
    $('#home-slider').addClass('loaded');
  }


  function ajax_submit(url,form,waitbutton){


    var postData = $(form).serialize() + '&action=form_traitement';
    var postUrl = "/wp-admin/admin-ajax.php";

    var oldText = $(waitbutton).text();
    $(waitbutton).html('<i class="fa fa-refresh fa-spin"></i>');

    //Important pour bloquer pendant la sauvegarde
    $.ajaxSetup({'async': false});

    $.ajax({
      type:"POST",
      url: postUrl,
      data: postData,
      dataType: "json",
      success:function(data){
        //alert('success!');
        if (typeof data.message.success != 'undefined'){
          $('#alert_message').html('');
          $( "#sendHtmlEmail" ).fadeOut(500, function() {
            $('#contact_success').fadeIn(500);
          });
          $(waitbutton).text(oldText);
        } else if (typeof data.message.error != 'undefined') {

          message = '<p class="error">'+ data.message.error + '</p>';

          $('#alert_message').html(message).fadeIn(500);
          $(waitbutton).text(oldText);
        }
      }
    });
  }

  $('#sendEmail').unbind('click');
  $('#sendEmail').click(function(e) {
    e.preventDefault();
    $("#sendHtmlEmail").submit(ajax_submit($(this).data('url'),"#sendHtmlEmail",'#sendEmail'));
    //alert('submitting');
    return false;
  });

  // --------------------------------------------------
  // Portfolio Tiles
  // --------------------------------------------------

  function setTiles() {

    // Mobile
    $('.touch .tile').on(eventtype, function(ev){
      $('.tile').removeClass('hover');
      $(this).addClass('hover');
    });

    // Desktop
    $('.no-touch .tile').on({
      mouseenter: function(){
        $(this).addClass('hover');
        $(this).find('a.more').addClass('active');
        //clickTile();
      },
      mouseleave: function(){
        $(this).removeClass('hover');
        $(this).find('a.more').removeClass('active');
      }
    });
  }

  setTiles();

  // --------------------------------------------------
  // Video Lightbox
  // --------------------------------------------------

  var refUrl = window.location.href;
  var isVideoLoading = false;

  function showReelLightbox() {
    $('#video-lightbox').addClass('open');
  }

  $('#watch-reel').on('click', function(e) {
    e.preventDefault();
    var movieEmbed = '';
    var movieID = $(this).attr('href');



    if (movieID.match(/vimeo\.com/i)) {
      movieID = movieID.split('/');
      movieID = movieID[3];
      movieEmbed = '<iframe src="https://player.vimeo.com/video/'+ movieID +'?api=1&color=4d4d4d" width="1281" height="720" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
    } else if (movieID.match(/youtu\.be/i)) {
      movieID = movieID.split('/');
      movieID = movieID[3];
      console.log(movieID[3]);
      movieEmbed = '<iframe id="player" src ="https://www.youtube.com/embed/'+ movieID +'?showinfo=0" width="1280" height="720" frameborder="no" allowfullscreen></iframe>';
    }


    $('#video-player').empty().append(movieEmbed);
    $('#video-lightbox').addClass('open');

    var scrollPosition = $('body').scrollTop();
    $('.no-touch body').css('top', -($('body').scrollTop()) + 'px').addClass('noscroll');
    $("html.touch").css("overflow", "hidden");

    $('.demo-reel #close-video').on('click', function(e){
      e.preventDefault();
      var thisParent = $('#video-lightbox.demo-reel');
      $(thisParent).find('#video-player').empty();
      $(thisParent).removeClass('open');
      $('body').removeAttr('style').removeClass('noscroll').scrollTop(scrollPosition);
      return false;
    });

    return false;
  });

  //var	clicktype = mobilecheck() ? 'touchstart' : 'click';
  $('.tile a.more').unbind( 'click.animsition' );
  $('#home-slider a.btn').unbind( 'click.animsition' );


  


  function openProject(projectUrl, fromUrl) {
    refUrl = fromUrl;
    isVideoLoading = true;
    $.ajax({
      type: 'GET',
      url: projectUrl,
      dataType: 'html',
      success: function(out){
        var projectHTML = $(out).find('#lightbox-wrapper').html();
        var vimeoId =  $(out).find('#vimeoPlayer').data('video-id');
        $('#lightbox-wrapper').append(projectHTML);
        if(vimeoId) {
          const player = new Player('vimeoPlayer', {
            id: vimeoId,
            title: false,
            byline: false,
            color: '4d4d4d',
            width: 1080
          });
        }
      }
    }).done(function(){
      $('#video-lightbox').addClass('open loaded');
      $('.tile.loading').removeClass('loading');
      window.history.pushState({href: projectUrl}, '', projectUrl);
      isVideoLoading = false;
    });
  }

  $(document).on('click', '.tile a.more', function(e){
    e.preventDefault();
    if (!isVideoLoading) {
      var thisUrl = $(this).attr('href');
      var thisTile = $(this).parents('.tile');
      var thisRef = window.location.href;
      $(thisTile).addClass('loading');
      openProject(thisUrl,thisRef);
    }
    return false;
  });

  $(document).on('click', '.infoBlock a.btn', function(e){
    e.preventDefault();
    var thisUrl = $(this).attr('href');
    var thisRef = window.location.href;
    openProject(thisUrl,thisRef);
    return false;
  });

  $(document).on('click', '#close-video', function(e){
    e.preventDefault();
    $('#video-lightbox').removeClass('open loaded');
    window.history.pushState({href: refUrl}, '', refUrl);
    setTimeout(function() {
      $('#lightbox-wrapper').empty();
    }, 750);
    return false;
  });

   

  //------------------------------------------------------------------------
  // Load More - Portfolio
  //------------------------------------------------------------------------

  $('#tiles-wrapper').infiniteScroll({
    // options
    path: '.infinite-more-link',
    append: '.item',
    history: false,
    hideNav: '#load-more-wrapper',
    status: '.scroller-status',
    scrollThreshold: 100
  });

  $('#tiles-wrapper').on('append.infiniteScroll', function(event, response, path, items) {
    setTiles();
  });

  // --------------------------------------------------
  // Window Resize Functions
  // --------------------------------------------------
  $(window).on('resize', function(){
    // Reset Stuff
    resetPanels();

    // Set it back
    setPanels();
  });

});
